module.exports = __webpack_public_path__ + "img/safebox.2bf34528.png";